<template>

  <select-input
  :label="label"
  v-model="formData"
  value-key="value"
  label-value="label"
  :placeholder="placeholder"
  :size="size"
  :list="selectData"
  :required="required"
  :disabled="disabled" @change="updated">
    <!-- XOL-596: forwards the trailing cue slot into the select's form item. -->
    <template #cue><slot name="cue"></slot></template>
  </select-input>

</template>

<script>

export default {
  name: 'select-service-type',
  props: {
    label: {
      type: String,
      default: 'Service Type'
    },
    value: {
      //      type: String,
      required: true
    },
    prop: {
      type: String,
      default () { return this.label }
    },
    size: {
      type: String,
      default: 'normal'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    }
  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      selectData: this.getConfig().selects.serviceType
    }
  }
}
</script>
